<template>
  <span @blur="showCurrencies = false">
    <span 
      @click="showCurrencies = !showCurrencies" 
      class="d-flex justify-content-center"
    >
      <small
        v-if="selectedCurrency.symbloLeft"
        class="m-pricingCard1__currency"
      >
        {{ selectedCurrency.symblo }}
      </small>
      {{ finalValue | moneyDBtoDisplay }}
      <small
        v-if="!selectedCurrency.symbloLeft"
        class="m-pricingCard1__currency"
      >
        {{ selectedCurrency.symblo }}
      </small>
      <br>
    </span>
    <slot></slot>
    <span class="currency-select">
      <select
        @change="setSelectedCurrencies(currencyId)"
        @blur="showCurrencies = false"
        v-model="currencyId"
        class="mt-2 form-control"
      >
        <option
          v-for="currency in currencies"
          :key="currency.id"
          :value="currency.id"
        >
          {{ $tc(`currency.${currency.code}`, 1) }}
        </option>
      </select>
    </span>

  </span>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
  name: "CurrencyFactor",
  props: {
    value: {
      type: Number
    }
  },
  data() {
    return {
      showCurrencies: false
    }
  },
  computed: {
    ...mapState('utils', [
      'currencies',
      'selectedCurrencyId'
    ]),
    ...mapGetters('utils', [
      'selectedCurrency'
    ]),
    finalValue() {
      return this.value * this.selectedCurrency.factor;
    },
    currencyId: {
      get() {
        return this.selectedCurrencyId;
      },
      set(newValue) {
        return this.setSelectedCurrencies(newValue);
      }
    }
  },

  mounted() {
    this.setCurrence();
  },

  methods: {
    ...mapMutations('utils', [
      'setSelectedCurrencies'
    ]),

    setCurrence() {
      const LANG_CODE = localStorage.LangCode;

      if (LANG_CODE.includes('br')) {
        this.setSelectedCurrencies(4);
      } else if (LANG_CODE.includes('pt')) {
        this.setSelectedCurrencies(1);
      } else {
        this.setSelectedCurrencies(2);
      }
    },

    onClick() {
      this.$emit("on-click", this.index);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import 'src/assets/css/patterns.scss';

  small {
    opacity: 0.6;
  }

  .edit-currency {
    width: 15px;
    opacity: 1;

    &:hover {
      opacity: 1;
    }
  }

	.currency-select {
		color: #ccc;
		text-indent: 5px;
		transition: opacity 0.8s ease;

		&:hover {
			opacity: 1;
		}

		select {
			width: 90px;
			margin: 0 auto;
			text-align: center;
			text-align-last:center;
			color: $gray-800;
			background: $gray-50;
			text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);

			&:focus {
				color: $gray-800;
				text-align: center;
			}

			option {
				text-align: center;
			}
		}
	}
</style>
